import * as React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import defaultStyles from '../../../../styles/formSetStyles.module.css';

import * as api from '../../../../api';

import { Button, Margin } from '../../../Button';
import { MultiEnum } from '../../MultiEnum';
import { Option } from '../../../utils';

interface Props extends WithTranslation {
  livesWith: api.PatientEnvironment.LivesWith[];
  livesWithOptions: Option<api.PatientEnvironment.LivesWith>[];
  updateLivesWith: (livesWithValue: api.PatientEnvironment.LivesWith[]) => void;
  setIsLivesWithModalOpen: (newState: boolean) => void;
}

interface State {
  patientEnvironment: api.PatientEnvironment.PatientEnvironment | null;
}

class LivesWith extends React.Component<Props, State> {
  handleSelect = (newValue: api.PatientEnvironment.LivesWith) => {
    const { livesWith, updateLivesWith } = this.props;
    const needsRemove = livesWith.includes(newValue);

    if (needsRemove) {
      updateLivesWith(livesWith.filter((value) => value !== newValue));
      return;
    }

    updateLivesWith([...livesWith, newValue]);
  };

  render() {
    const { livesWith, livesWithOptions, setIsLivesWithModalOpen, t } =
      this.props;

    return (
      <>
        <div className={defaultStyles.Label}>
          {t('Who do you live with? Select all that apply.')}
        </div>
        <MultiEnum
          values={livesWith}
          options={livesWithOptions}
          onItemClick={this.handleSelect}
        />
        <Button
          type="button"
          children={this.props.t('Continue')}
          onClick={() => setIsLivesWithModalOpen(false)}
          margin={Margin.Enum}
        />
      </>
    );
  }
}

const LivesWithModalContent = withTranslation()(LivesWith);
export default LivesWithModalContent;
